// Vite entrypoint for the SSR landing/waitlist page
import '../js/shared/fonts.ts'
import { enforcePreferredLocale } from '../js/shared/auth-locale-redirect.ts'
enforcePreferredLocale()
import { initAppsignal } from '../js/shared/appsignal.ts'
initAppsignal()
import '../css/style.css'
import '../css/waitlist.css'
import '../css/landing-blueprint.css'
import '../js/components'
import { initI18n } from '../js/shared/i18n.ts'
import { initLanding } from '../js/pages/landing'
import { initFeedback } from '../js/pages/feedback.ts'
import { initSearch } from '../js/shared/search.ts'

document.addEventListener('DOMContentLoaded', async () => {
  await initI18n()
  initSearch()
  initLanding()
  initFeedback()
})
